import React, { useEffect, useRef, useState } from "react";
import { Container, Row, Col, Card, Button, Form, Spinner } from "react-bootstrap";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import TabSlider from "./tabslider";
import { useNavigate } from "react-router-dom";
import { failedMessage } from "utils/httpClient";
import { apiCall } from "utils/httpClient";
import apiEndPoint from "utils/apiEndPoint";
import { isEmpty } from "utils/utils";
import ResponsivePagination from 'react-responsive-pagination';
import 'react-responsive-pagination/themes/classic.css';
import { saveToLocalStorage } from "utils/LocalStorageUtils";
import TemplateViewing from "pages/modalPopup/templateViewing";
import { loadFromLocalStorage } from "utils/LocalStorageUtils";
import LoginAskModal from "pages/loginaskmodal";
import { FaBookmark, FaRegBookmark } from "react-icons/fa";


const TemplateGallery = () => {
  const navigate = useNavigate();
  const boxRef = useRef(null);
  const [showModal, setShowModal] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [isAuth, setIsAuth] = useState(false);

  const [languageData, setLanguageData] = useState(null);
  const selectLang = loadFromLocalStorage("SELECTLANGUAGE");
  useEffect(() => {
    setLanguageData(selectLang?.language)
  }, [selectLang])
  useEffect(() => {
    const authData = loadFromLocalStorage("AUTH_DATA");
    if (authData?.token) {
      setIsAuth(true)
    }
  }, []);

  const handleViewClick = (template) => {
    setSelectedTemplate(template);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedTemplate(null);
  };

  const urlParams = new URLSearchParams(window.location.search);
  const isFavourite = urlParams.get('is_favourite');
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [templatesList, setTemplatesList] = useState([]);
  const [selectCategoryId, setSelectCategoryId] = useState('');
  const [searchCategory, setSearchCategory] = useState('');

  const [pageChanging, setPageChanging] = useState(false);

  const getTemplatesList = async (item = '', offset = 0) => {
    // setLoading(true)
    // let params = { limit: 9, offset: currentPage === 0 ? 0 : currentPage - 1, shuffle: false };
    let params = { limit: 12, offset: offset === 0 ? 0 : offset - 1, shuffle: false, order_by: 'asc' };
    if (!isEmpty(selectCategoryId)) {
      params["category_id"] = selectCategoryId;
    } else if (!isEmpty(localStorage.getItem('selectCategoryId'))) {
      params["category_id"] = localStorage.getItem('selectCategoryId');
    }
    if (!isEmpty(item)) {
      // delete params.category_id
      params["search_by"] = item
    }
    if (params.category_id != undefined && params.category_id != '') {
      delete params.search_by
    }
    const { data } = await apiCall("post", apiEndPoint.SEARCHTEMPLATE, params);
    if (data.status === 200) {
      setTemplatesList(data.data);
      setTotalPages(Math.ceil(data?.total_data / 12));
    } else {
      setTemplatesList([]);
      failedMessage(data.message);
    }
    await localStorage.setItem('selectCategoryId', '')
    setLoading(false)
  };
  useEffect(() => {
    if (!isEmpty(localStorage.getItem('selectCategoryId'))) {
      setSelectCategoryId(localStorage.getItem('selectCategoryId'))
    }
    getTemplatesList(searchCategory, currentPage)
  }, [currentPage, isFavourite])

  useEffect(() => {
    getTemplatesList(searchCategory, 0)
  }, [selectCategoryId])

  const handleAllTemplateData = () => {
    setSearchCategory('')
    setSelectCategoryId('')
    setCurrentPage(0)
    localStorage.setItem('selectCategoryId', '')
    getTemplatesList(searchCategory, 0)
  }
  const handlePageChange = async (page) => {
    setPageChanging(true);
    setCurrentPage(page);
    await getTemplatesList(searchCategory, page);
    setPageChanging(false);
  };

  const [categories, setCategories] = useState([]);
  const handleGetCategory = async (cat_name) => {
    if (!isEmpty(cat_name)) {
      const params = { limit: 20, offset: 0, category_name: cat_name }
      const { data } = await apiCall("post", apiEndPoint.GETCATEGORY, params);
      if (data.status === 200) {
        setCategories(data.data);
      } else {
        setCategories([]);
        // failedMessage(data.message);
      }
    } else {
      setCategories([]);
    }
  };
  const handleSelectCategory = (item) => {
    setSearchCategory(item?.category_name)
    setSelectCategoryId(item?._id);
    setCategories([])
  }

  const [showLoginAskModal, setShowLoginAskModal] = useState(false);
  const handleLoginAskModal = () => {
    setShowLoginAskModal(true);
  }
  const handleCloseLoginAskModal = () => {
    setShowLoginAskModal(false);
  }

  // Function to handle clicks outside the box
  const handleClickOutside = (event) => {
    if (boxRef.current && !boxRef.current.contains(event.target)) {
      setCategories([])
    }
  };


  useEffect(() => {
    // Add event listener for clicks
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      // Clean up the event listener
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const [savedItems, setSavedItems] = useState(new Set());

  const toggleSave = async (id) => {
    setSavedItems(prev => {
      const newSet = new Set(prev);
      if (newSet.has(id)) {
        newSet.delete(id);
      } else {
        newSet.add(id);
      }
      return newSet;
    });
    const params = { template_id: id }
    const { data } = await apiCall("post", apiEndPoint.ADDREMOVEWISHLISTTEMPLATE, params);
  };

  const toggleSaveTemp = async (id) => {
    setSavedItems(prev => {
      const newSet = new Set(prev);
      newSet.add(id);
      return newSet;
    });
  };
  const getWishlistTemplateList = async (id) => {
    const { data } = await apiCall("get", apiEndPoint.GETWISHLISTTEMPLATE);
    if (data.status === 200) {
      const array = data.data.map(item => toggleSaveTemp(item.template_id))
    }
  };

  useEffect(() => {
    getWishlistTemplateList()
  }, [])

  return (
    <Container>
      <div>
        {/* Filter Section */}
        <section className="services-section">
          <div className="container text-center">
            <h3 className="animate__animated animate__bounce" style={{ fontFamily: 'quicksand', fontWeight: 600, textAlign: 'center', margin: 'auto' }}>
              {languageData?.ourTemplates}
            </h3>
            <br />
            <p style={{ fontSize: 16, fontWeight: 600, maxWidth: 500, margin: 'auto', color: '#444' }}>
              {languageData?.createaStunningwebsite}
            </p>
          </div>
        </section>
        <Row className="my-4" style={{ borderBottom: "1px solid #ccc", paddingBottom: "1rem", display: 'flex', alignItems: 'center' }}>
          <Col lg={8} md={12}>
            <TabSlider
              setSelectCategoryId={setSelectCategoryId}
              searchCategory={searchCategory}
              handleAllTemplateData={handleAllTemplateData}
              languageData={languageData}
              setCurrentPage={setCurrentPage}
              selectCategoryId={selectCategoryId} // ✅ Make sure this is included
            />

          </Col>
          <Col lg={4} md={12}>
            <div style={{ position: 'relative' }}>
              <Form.Control className="form-margin-cst" type="text" placeholder={languageData?.typeYourNiche} onChange={(e) => { setSearchCategory(e.target.value); setSelectCategoryId(""); getTemplatesList(e.target.value, 0); handleGetCategory(e.target.value); setCurrentPage(0) }} value={searchCategory} style={{ borderRadius: 50, height: 30 }} />
              {categories.length > 0 &&
                <div ref={boxRef} style={{ width: '100%', marginTop: '0px', position: 'absolute', zIndex: 9 }}>
                  <div style={{ maxWidth: '600px', margin: 'auto', textAlign: 'left', padding: '7px 0rem', background: 'white', border: '1px solid #bfbfbf', borderRadius: '6px', marginTop: '0px' }}>
                    <ul style={{ listStyle: 'none', padding: 0, margin: 0, maxHeight: '290px', overflow: 'auto' }}>
                      {categories.map((item, i) => (
                        <li key={i} style={{ cursor: 'pointer', padding: '3px 13px', }} className="catListHome" onClick={() => { handleSelectCategory(item); setCurrentPage(0) }} >{item?.category_name}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              }
            </div>
          </Col>
        </Row>

        {(pageChanging || loading) ? (
          <div style={{ textAlign: 'center', marginTop: '4rem' }}>
            <Spinner animation="border" role="status" />
          </div>
        ) : (
          templatesList.length > 0 ? (
            <div>
              <Row>
                {templatesList.map((template, index) => (
                  <Col lg={3} md={6} sm={6} className="mb-4" key={index} style={{ padding: '0 18px' }}>
                    <Card className="position-relative" style={{
                      border: '2px solid #ccc',
                      borderRadius: '10px'
                    }}>
                      <Card.Img variant="top" className="img-template" src={template.thumbnail} alt={template.template_name} style={{ borderRadius: '8px' }} />
                      <div className="button-overlay">
                        <Button variant="outline-primary" className="me-2"
                          onClick={() => {
                            if (isAuth) {
                              saveToLocalStorage('selectTemplate', template); saveToLocalStorage("selectOrderDetail", null); navigate("/templateform")
                            } else {
                              handleLoginAskModal();
                            }
                          }}>
                          {languageData?.edit}
                        </Button>
                        <Button variant="primary" onClick={() => handleViewClick(template)}>
                          {languageData?.view}
                        </Button>
                      </div>
                    </Card>
                    {/* Save/Unsave Section */}
                    <div style={{ margin: '5px' }}>
                      <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                      }}>
                        <Card.Title style={{
                          fontSize: '14px',
                          margin: 0,
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          flexGrow: 1,
                          textTransform: 'capitalize'
                        }}>
                          {template?.title}
                        </Card.Title>

                        {isAuth &&
                          <span
                            onClick={() => toggleSave(template._id)}
                            style={{
                              cursor: 'pointer',
                              marginLeft: '10px',
                              flexShrink: 0,
                            }}
                            title={savedItems.has(template._id) ? 'Unsave' : 'Save'}
                          >
                            {savedItems.has(template._id) ? (
                              <FaBookmark color="#ff671f" />
                            ) : (
                              <FaRegBookmark color="#999" />
                            )}
                          </span>
                        }
                      </div>
                    </div>
                  </Col>
                ))}
              </Row>
              <div className="mt-4 box_pagination">
                <ResponsivePagination
                  current={currentPage}
                  total={totalPages}
                  onPageChange={handlePageChange}
                />
              </div>
            </div>
          ) : (
            <div style={{ textAlign: 'center', marginTop: '4rem' }}>
              <img src='/assets/images/nofound.png' style={{ textAlign: 'center', width: '60%' }} />
            </div>
          )
        )}

      </div>

      {/* Modal for Viewing Template */}
      <TemplateViewing showModal={showModal} handleCloseModal={handleCloseModal} selectedTemplate={selectedTemplate} handleCloseLoginAskModal={handleCloseLoginAskModal} showLoginAskModal={showLoginAskModal} handleLoginAskModal={handleLoginAskModal} />
      {showLoginAskModal && <LoginAskModal handleCloseLoginAskModal={handleCloseLoginAskModal} showLoginAskModal={showLoginAskModal} />}
      {/* <Modal
        show={showModal}
        onHide={handleCloseModal}
        centered
        size={activeTab === "Desktop" ? "xl" : "md"} // Set modal size based on active tab
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <h6>{selectedTemplate?.title}</h6>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Nav variant="tabs" activeKey={activeTab} onSelect={(selectedTab) => setActiveTab(selectedTab)} className="justify-content-center text-center align-items-center">
            <Nav.Item>
              <Nav.Link eventKey="Desktop">
                <FaDesktop className="me-2" />
                Desktop
              </Nav.Link>
            </Nav.Item>
            <div className="nav-separator"></div> 
            <Nav.Item>
              <Nav.Link eventKey="Mobile">
                <FaMobileAlt className="me-2" />
                Mobile
              </Nav.Link>
            </Nav.Item>
          </Nav>

          <iframe src={selectedTemplate?.template_path} width="100%" height="650"></iframe>

        </Modal.Body>
        <Modal.Footer>
          <Button href='/templateform' variant="secondary" onClick={handleCloseModal}>
            Edit This Template
          </Button>
        </Modal.Footer>
      </Modal> */}
    </Container >
  );
};

export default TemplateGallery;
